<template>
    <div class="pro_modal">
        <div v-if="false">
            <div @click="$GlobalStore.hideCompleteProCondition()" v-if="$GlobalStore.isShowCompleteProCondition()" style="position: fixed; top: 0; left: 0; width: 100%; height: 100%; background-color: rgba(0, 0, 0, 0.2); z-index: 10;"></div>
            <div class="basic_frame" :class="{ open: $GlobalStore.isShowCompleteProCondition() }">
                <div style="margin-left: -6px;" @click="$GlobalStore.hideCompleteProCondition()">
                    <img style="width: 40px;" :src="require('@/assets/img/recent_x_btn.png')" alt="">
                </div>
                <div style="">
                    <div style="display: flex; flex-direction: column; align-items: center; margin-top: 20px;">
                        <div>
                            <img style="width: 58px;" :src="require('@/assets/img/complete_condition.png')" alt="">
                        </div>
                        <div style="margin-top: 12px; font-size: 32px; line-height: 46px;">조건을 달성했습니다!</div>
                        <div style="text-align: center; line-height: 24px; margin-top: 8px;">포지션 찾기 PRO 1회권을 드렸습니다<br>지금 포지션 찾기 PRO를 무료로 시작해보세요</div>
                    </div>
                    <div @click="findPositionPro" style="border-radius: 30px; margin-top: 20px; margin-bottom: 20px; padding: 10px; background-color: #210f03; color: #fff; line-height: 24px; font-size: 14px; text-align: center; font-weight: 500;">포지션 찾기 PRO 시작하기</div>
                </div>
            </div>
        </div>
        <div v-else>
            <div @click="closeModal" v-if="$GlobalStore.isShowCompleteProCondition()" style="position: fixed; top: 0; left: 0; width: 100%; height: 100%; background-color: rgba(0, 0, 0, 0.2); z-index: 10;"></div>
            <div class="basic_frame" :class="{ open: $GlobalStore.isShowCompleteProCondition() }">
                <div @click="closeModal" style="margin-left: -6px;">
                    <img style="width: 40px;" :src="require('@/assets/img/recent_x_btn.png')" alt="">
                </div>
                <div style="">
                    <div style="display: flex; gap: 12px;  margin-top: 20px;">
                        <div class="circle_progress_wrap">
                            <svg class="circle_progress" width="24" height="24" viewBox="0 0 24 24">
                                <circle class="frame" cx="12" cy="12" r="10" stroke-width="4" />
                                <circle :style="{ strokeDashoffset: 32.4149 + 'px' }" style="stroke-dasharray:78.8318px;" class="bar" cx="12" cy="12" r="10" stroke-width="4" />
                            </svg>
                        </div>
                        <div style="display: flex; gap: 4px;">
                            <div>
                                <img style="width: 17px;" :src="require('@/assets/free_position_pro.png')" alt="">
                            </div>
                            <div>
                                <div style="font-size:20px; font-weight: 700; line-height: 24px; margin-bottom: 8px;">친구나 용병 1명을 내 스케줄<br>에 참여시키기</div>
                                <div style="font-size: 14px;font-weight: 500;line-height: 24px; color: #606060;">초대를 하거나 같이 축구할 사람을 찾아 내<br>스케줄에 참여하게 만드세요. 딱 1명만 들어<br>오면 조건이 달성됩니다!</div>
                            </div>
                        </div>
                    </div>
                    <div @click="inviteMySchedule" style="border-radius: 30px; margin-top: 20px; margin-bottom: 20px; padding: 10px; background-color: #210f03; color: #fff; line-height: 24px; font-size: 14px; text-align: center; font-weight: 500;">내 스케줄에 초대하기</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'CompleteProCondition',
    methods: {
        findPositionPro() {
            this.$GlobalStore.hideCompleteProCondition()
            this.$GlobalStore.addModal('MyPositionPro', { is_free: true });
        },
        inviteMySchedule() {
            this.closeModal()
            this.$GlobalStore.addModal('InviteMemberPopup', { transitionName: '', isModalBackTransparent: true, region_code: this.$GlobalStore.shareRegionCode() })
        },
        closeModal() {
            localStorage.removeItem('isShowSchedulePopup')
            this.$GlobalStore.hideCompleteProCondition()
        }
    }
}
</script>

<style>
.pro_modal {
    position: fixed;
    width: 100%;
    height: 100%;
    left: 0px;
    top: 0px;
    z-index: 10;
}

.basic_frame {
    width: 342px;
    background-color: #fff;
    padding: 20px 24px;
    border-radius: 24px;
    position: absolute;
    top: 100%;
    left: 50%;
    transform: translate(-50%, 0);
    transition: 0.5s all;
    z-index: 20;
    /* text-align: center; */
    font-weight: 500;
}

.basic_frame.open {
    top: 50%;
    transform: translate(-50%, -50%);
}

.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.5s;
}

.fade-enter,
.fade-leave-to {
    opacity: 0;
}

.fade2-enter-active,
.fade2-leave-active {
    transition: all .5s;
}

.fade2-enter,
.fade2-leave-to {
    top: 100%;
    opacity: 0;
}

.circle_progress_wrap {
    position: relative;
    width: 24px;
    height: 24px;
}

.ellipsis {
    text-overflow: ellipsis;
    overflow: hidden;
    -webkit-line-clamp: 1;
    display: -webkit-box;
    -webkit-box-orient: vertical
}

.circle_progress {
    transform: rotate(-90deg);
}

.frame,
.bar {
    fill: none;
}

.frame {
    stroke: #ebebeb;
}

.bar {
    stroke: var(--color-main);
    stroke-linecap: round;
}

.value {
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    top: 0;
    text-align: center;
    color: #888;
    font-size: 16px;
    line-height: 120px;
}

.circle {
    width: 5px;
    height: 5px;
    background-color: #210f03;
    border-radius: 50%;
}
</style>